import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { setSubmissionStage } from 'actions';

export const FORM_SUBMIT_REQUEST = 'FORM_SUBMIT_REQUEST';
export const FORM_SUBMIT_COMPLETE = 'FORM_SUBMIT_COMPLETE';

function request() {
  return {
    type: FORM_SUBMIT_REQUEST,
  };
}

function complete() {
  return {
    type: FORM_SUBMIT_COMPLETE,
  };
}

export function submitForm(id, stage) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .submit(id)
      .then((response) => {
        dispatch(setSubmissionStage(stage));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, complete, true, false));
        }
      });

    return promise();
  };
}
